import imagesQuery from '../../../assets/js/queries/images-query';

export default `
	headline
	${imagesQuery}
`;
